export const tableHead = [
  // {
  //   type: 'formatter',
  //   label: '课程分类',
  //   formatter: null
  // },
  {
    prop: 'category',
    label: '课程分类'
  },
  {
    prop: 'name',
    label: '课程名称'
  }, {
    prop: 'code',
    label: '课程编码'
  },
  {
    prop: 'detail_count',
    label: '课程总时'
  },
  {
    prop: 'created_at',
    label: '创建时间'
  },
  {
    prop: 'updated_at',
    label: '更新时间'
  },
  {
    prop: 'sale_time',
    label: '最近上架时间'
  },
  // {
  //   type: 'formatter',
  //   label: '上下架状态',
  //   width: '180',
  //   formatter: (row) => {
  //     const type = {
  //       1: '上架',
  //       2: '下架'
  //     }
  //     return type[row.sale_status]
  //   }
  // },
  // {
  //   prop: 'sale_status_text',
  //   label: '上下架状态'
  // }
]

export const formData = [
  {
    typeName: 'select1',
    placeholder: '请选择年级',
    model: 'equal[stage_tag_id]',
    options: []
  },
  {
    typeName: 'select1',
    placeholder: '请选择科目',
    model: 'equal[subject_tag_id]',
    options: []
  },
  {
    typeName: 'select1',
    placeholder: '上下架状态',
    model: 'equal[sale_status]',
    options: [
      {
        value: 2,
        label: '下架'
      },
      {
        value: 1,
        label: '上架'
      }
    ]
  },
  {
    typeName: 'inputSearch',
    placeholder: '请输入课程包名称',
    model: 'like[name]'
  }
]



// WEBPACK FOOTER //
// ./src/views/CourseOn/putOn/fields.js